import React, { useMemo } from 'react';
import { Card, CardContent, Tooltip } from '@material-ui/core';
import ReactHighcharts from 'react-highcharts';

const BORDER_COLOR = '#666666';
const LOADING = 'Loading...';
const SOURCE = '';

const styleArrowDown = {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '18.4px 10px 0',
    borderColor: '#f02d5b transparent transparent transparent',
  }
  const styleArrowUp = {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    borderWidth: '0 10px 18.4px',
    borderColor: 'transparent transparent #49b27b transparent',
  };

const SummarySectionComponent = ({title, tooltip, slope, color, min, max, intercept, value, graphValues, labelPreFix='', loading, ...props}) => {
    const valsMax = useMemo(() => graphValues.reduce((prev, current) => (prev.y > current.y) ? prev : current, {}), [graphValues]);
    const valsMin = useMemo(() => graphValues.reduce((prev, current) => (prev.y < current.y) ? prev : current, {}), [graphValues]);
  
    let minMarked, maxMarked;
    const vals = useMemo(() => graphValues.map(x => {
      if (x.y === valsMax.y && !maxMarked) { x.label = `Max (${max})`; maxMarked = true; };
      if (x.y === valsMin.y && !minMarked) { x.label = `Min (${min})`; minMarked = true; };
      return x;
    }), [valsMax, valsMin]);

    const metricName = useMemo(() => tooltip.charAt(0).toUpperCase() + tooltip.slice(1), [tooltip]);
  
    let widgetConfig = useMemo(() => ({
      chart: {
        id: `${tooltip}Chart`,
        renderTo: 'container',
        zoomType: 'x',
        height: '40%',
        backgroundColor: 'none',
        borderColor: BORDER_COLOR,
        borderWidth: 0,
      },
      title: { text: '' },
      subtitle: { text: loading ? LOADING : SOURCE },
      xAxis: {
        type: 'datetime',
        labels: {
          format: '{value:%e-%b}',
          style: {
            color: '#ffffff',
            fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
          }
        },
        crosshair: true,
        gridLineWidth: 0
      },
      yAxis: [{
        labels: {
          style: {
            color: '#ffffff',
            fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
          }
        },
        title: {
          text: '',
          style: {
            color: '#ffffff',
            fontWeight: 'bold',
            fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
          }
        },
        min: 0,
        gridLineWidth: 0
      }],
      series: [
        {
          name: metricName,
          shadow: true,
          color: color,
          yAxis: 0,
          data: loading ? [] : vals,
          dataLabels: {
            enabled: true,
            style: {
              color: 'white',
              fontSize: '10px',
              verticalAlign: 'middle',
              textOutline: 'none'
            },
            formatter: function() {
              return this.point.label ? this.point.label : undefined;
            }
          }
        }
      ],
      legend: false,
      credits: { enabled: false }
    }), [vals, loading]);
  
    return (
      <div style={{width: '100%'}}>
  
        <Card style={{height: '100%', backgroundColor: '#3e3e3e'}} raised>
          <CardContent style={{ textAlign: 'center', fontSize: '37px', fontWeight: '600', color: 'white' }}>
            <div style={{ textAlign: 'center', color: 'white', fontSize: '12px' }}>{title}</div>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', margin: '5px 0 0 0'}}>
              <p style={{ fontSize: '25px', margin: '0' }}>{value}</p>
              <Tooltip title={`Slope: ${slope} | Intercept: ${intercept}`} >
                <div style={(parseFloat(slope) >= 0) ? styleArrowUp : styleArrowDown}/>
              </Tooltip>
            </div>
            {/* <hr style={{ marginTop: '10px' }} /> */}
            <ReactHighcharts config={widgetConfig} isPureConfig={true} style={{width: '100%'}} />
          </CardContent>
        </Card>
  
      </div>
    )
  }

export default SummarySectionComponent;